module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "d-flex": ""
    }
  }, _vm._l((_vm.filterActive), function(filter) {
    return _c('v-flex', {
      key: filter.id,
      staticClass: "filter-list",
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "mr-0",
      class: {
        'active': filter.active
      },
      on: {
        "click": function($event) {
          _vm.selectFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(filter.name) + "\n\t\t\t\t")])], 1)
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-flex', [_c('button-create', {
    attrs: {
      "text": "Crear Vendedor",
      "href": _vm.createHref
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('table-run', {
    attrs: {
      "switch-value": "flagActive",
      "include-switch": true,
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-settings": true,
      "option-buttons": _vm.optionButtons
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "go-to-edit-page": _vm.goToEdit,
      "custom-button": _vm.customButton,
      "on-change-state": _vm.changeState
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.appointment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.subsidiary))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.isVisibleModal) ? _c('modal-user', {
    attrs: {
      "width": "439px",
      "height": "460px",
      "row": _vm.listUser
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34cb4426","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/users/List.vue
// module id = 1617
// module chunks = 29